import { Button, Icon } from '@vestigas/ui';

type P = {
  readonly disabled: boolean;
  readonly file: File | undefined;
  readonly onClear: () => void;
  readonly removeLabel: string;
};

export function FileRow({ disabled, file, onClear, removeLabel }: P) {
  if (!file) {
    return null;
  }

  return (
    <div className="flex min-w-0 items-center gap-2">
      <p
        className="flex-1 truncate text-sm text-tiga-text-default"
        title={file.name}
      >
        {file.name}
      </p>
      <Button
        aria-label={removeLabel}
        className="-my-2"
        disabled={disabled}
        icon={<Icon metaphor="close" />}
        onClick={onClear}
      />
    </div>
  );
}
